<h2>Balance log</h2>
<div class="container balance-log-container">

  <form class="balance-history-form" [formGroup]="balanceHistoryForm">

    <mat-form-field appearance="outline" class="selector">
      <mat-label>Wallet</mat-label>
      <mat-select formControlName="walletTypes" panelClass="recent-operation-select-panel" multiple>
        <div class="mat-select-list">
          <ng-container *ngIf="walletTypesById$ | async as walletTypesById">
            <mat-option *ngFor="let wallet of walletOptions$ | async"
                        [value]="walletTypesById.get(wallet.walletType.id)?.walletType">
              {{ walletTypesById.get(wallet.walletType.id)?.title || WalletTypeIdEnum[wallet.walletType.id] }} -
              <b>{{ wallet.balance / 100 | currency: 'USD' }}</b>
            </mat-option>
          </ng-container>
        </div>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="selector">
      <mat-label>Agent</mat-label>
      <mat-select formControlName="agentKeys" panelClass="recent-operation-select-panel" multiple>
        <div class="mat-select-list">
          <mat-option *ngFor="let agent of AgentKeyEnum | keyvalue"
                      [value]="agent.value">{{ agent.key }}
          </mat-option>
        </div>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="selector">
      <mat-label>Type</mat-label>
      <mat-select formControlName="typeIds" panelClass="recent-operation-select-panel" multiple>
        <div class="mat-select-list">
          <mat-option *ngFor="let trxType of enumValues(WalletTransactionTypeIdEnum)"
                      [value]="+trxType">{{ WalletTransactionTypeIdEnum[+trxType] }}
          </mat-option>
        </div>
      </mat-select>
    </mat-form-field>

    <button mat-stroked-button color="primary" (click)="apply()">apply</button>

  </form>

  <div class="balance-history-table-container">
    <div class="table-wrapper table-density">
      <div class="table-loading" *ngIf="balanceHistorySource.isLoading$ | async">
        <mat-spinner diameter="20" style="margin: 0 auto"></mat-spinner>
      </div>
      <table mat-table [dataSource]="balanceHistorySource " class="table balance-history-table" matSort>

        <ng-container matColumnDef="wallet">
          <th mat-header-cell *matHeaderCellDef>Wallet</th>
          <td mat-cell *matCellDef="let element">
            {{ (walletTypesById$ | async)?.get(element.wallet?.walletType?.id)?.title || WalletTypeIdEnum[element.wallet?.walletType?.id] || '-' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="agentKey">
          <th mat-header-cell *matHeaderCellDef>Agent</th>
          <td mat-cell *matCellDef="let element">{{ element.agentKey }}</td>
        </ng-container>

        <ng-container matColumnDef="amount">
          <th mat-header-cell *matHeaderCellDef>Amount</th>
          <td mat-cell *matCellDef="let element">
            <span appHighlightAmount value="{{element.amount}}">{{ element.amount / 100 | currency : 'USD' }}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="type">
          <th mat-header-cell *matHeaderCellDef>Type</th>
          <td mat-cell *matCellDef="let element">{{ WalletTransactionTypeIdEnum[element.type] }}</td>
        </ng-container>

        <ng-container matColumnDef="data">
          <th mat-header-cell *matHeaderCellDef>Data</th>
          <td mat-cell *matCellDef="let element">{{ element.data | json }}</td>
        </ng-container>

        <ng-container matColumnDef="createdAt">
          <th mat-header-cell *matHeaderCellDef>Timestamp</th>
          <td mat-cell *matCellDef="let element">{{ element.createdAt | date: 'dd.MM.yy HH:mm' }}</td>
        </ng-container>

        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" [attr.colspan]="balanceHistoryColumns.length">
          </td>
        </tr>

        <tr mat-header-row *matHeaderRowDef="balanceHistoryColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: balanceHistoryColumns;"></tr>
      </table>
    </div>
    <mat-paginator [length]="balanceHistorySource.totalCount"
                   [pageSizeOptions]="[100, 250, 500]">
    </mat-paginator>
  </div>
</div>
